import React from 'react';

import { useStyles } from './styles';

interface BillingAccount {
  id?: string;
  isSMBAccount?: boolean;
  // Default card info from GraphQL BillingCard type
  default_card?: {
    brand?: string;
    last4digits?: string;
  };
}

interface PaymentMethodDisplayProps {
  billingAccount?: BillingAccount | null;
  onChangePaymentMethod?: () => void;
}

/**
 * Displays the user's saved payment method for SMB consultations.
 *
 * Shows card brand icon, masked card number, and expiry.
 * Includes a "Change" link to update payment method.
 */
export function PaymentMethodDisplay({
  billingAccount,
  onChangePaymentMethod,
}: PaymentMethodDisplayProps): JSX.Element {
  const s = useStyles();

  const card = billingAccount?.default_card;

  if (!card?.last4digits) {
    return (
      <div className={s.paymentMethodEmpty}>
        <p className={s.paymentMethodEmptyText}>
          No payment method on file.{' '}
          {onChangePaymentMethod && (
            <button type="button" className={s.changePaymentLink} onClick={onChangePaymentMethod}>
              Add payment method
            </button>
          )}
        </p>
      </div>
    );
  }

  const brand = card.brand?.toUpperCase() || 'CARD';
  const last4 = card.last4digits;

  return (
    <div className={s.paymentMethod}>
      <div className={s.paymentMethodInfo}>
        <span className={s.cardBrand}>{brand}</span>
        <span className={s.cardNumber}>•••• {last4}</span>
      </div>
      {onChangePaymentMethod && (
        <button type="button" className={s.changePaymentLink} onClick={onChangePaymentMethod}>
          Change
        </button>
      )}
    </div>
  );
}

export default PaymentMethodDisplay;
